"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;
var _default = {
  isType: function isType(identifier) {
    var n = identifier.substr(3); // Default to int256

    return n || (n = 256), identifier.startsWith("int") && 0 == n % 8 && 256 >= n;
  }
};
exports.default = _default;